import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

abstract class HttpCache {
    abstract get(req: HttpRequest<any>): HttpResponse<any> | undefined
    abstract put(req: HttpRequest<any>, response: HttpResponse<any>): void
}

@Injectable()
export class RequestCacheService implements HttpCache {

    cache = new Map();

    get(req: HttpRequest<any>): HttpResponse<any> | undefined {
        return this.cache.get(req.urlWithParams);
    }

    put(req: HttpRequest<any>, response: HttpResponse<any>): void {
        this.cache.set(req.urlWithParams, response);
    }
}